import { render, staticRenderFns } from "./editFeeRule.vue?vue&type=template&id=415d85c7"
import script from "./editFeeRule.vue?vue&type=script&lang=js"
export * from "./editFeeRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports